import styled, {keyframes} from "styled-components";
import {JackpotToastCurrencyDefaultBox} from "./jackpot-toast-currency.default.box";

const amountShadowAnimation = (color: string) => keyframes`
    0% {
        text-shadow: 0px 0px 10px ${color};
    }
    100% {
        text-shadow: 0px 0px 20px ${color};
    }
`;

export const JackpotToastCurrencyCasino777Box = styled(JackpotToastCurrencyDefaultBox)`
    color: ${props => props.theme.colors.moneyColor};
    text-shadow: 0px 0px 5px ${props => props.theme.colors.moneyColor};
    animation: ${props => amountShadowAnimation(props.theme.colors.moneyColor)} 0.8s ease-in-out infinite alternate forwards;

    .decimals {
        font-size: 2.2rem;
        @media ${props => props.theme.mediaQuery.mAndBelow} {
            font-size: 2rem;
        }
    }
`;